import type { FaireProductEntity } from "../../entity_types/product";

export const p_3q7hrufwrb: FaireProductEntity = {
  token: "p_3q7hrufwrb",
  type: "product",
  name: "Crew Neck Striped Cotton T-Shirt Maxi Dress VD82246",
  brandToken: "b_2s1gu6rdak",
  brandName: "Vine & Love",
  imageUrl:
    "https://cdn.faire.com/fastly/1d95461d419fcb7c0afc79520289f02a7ebcf265050cd00479c3c40eb3cac875.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/125ab89b25ea9bc088439bc2fd159cba27d4525bc9bcade7175ebee3ee039574.jpeg",
    "https://cdn.faire.com/fastly/e3ed688c334e2119b0d96e349d0129832e2c510480dc4ff15a9d522151eff8ce.jpeg",
    "https://cdn.faire.com/fastly/bfbdbd29cd9949e3bea62c4191a9a46553f7b31a35ad88080fda58674ebffc47.jpeg",
    "https://cdn.faire.com/fastly/8d024c207b0ab42cf57b6f4ea14b5279a6899680d0cb685b4a792d5651628ae5.jpeg",
    "https://cdn.faire.com/fastly/c33bb5323b395cce3948bda6c78cca6dd1ac42377630ec52abd866ccaa369e77.jpeg",
    "https://cdn.faire.com/fastly/faecac2c557399c8433dd9ed57d96d78c8aa7ae6e2e9c487a54ce1d02d79bfbd.jpeg",
    "https://cdn.faire.com/fastly/2a6938db8032e3306c0521f76208b83fcf152fde6516191a99025e451c47208a.jpeg",
    "https://cdn.faire.com/fastly/613b39ba34a3e4d9693938a2765217be88b686d9120585a308679d9d12fb7bdb.jpeg",
    "https://cdn.faire.com/fastly/4da361ce8628713d5b143a710c9ca26d1698dd5d40b24fb6b25ee4a6949afeec.jpeg",
    "https://cdn.faire.com/fastly/02ab67f1971744f50b4c72d3b55959dff3908684398b9d93fc260ae325a99345.jpeg",
    "https://cdn.faire.com/fastly/4a2191063063fc1ab27e797f96a33895f96ebc1b103040dfce9a4beb524e390d.jpeg",
    "https://cdn.faire.com/fastly/c5f15b03c872f57fc1c82a158e987ed46fb8f051fb5a0b02bc5dbf71a121197c.jpeg",
    "https://cdn.faire.com/fastly/473fe74467c9c1435bf5668c92c81427375cefe72a99318a09a63fae8e88930e.jpeg",
    "https://cdn.faire.com/fastly/22bd03ec1c71280b65a2841fd65856cc6331c035bf9be68385864fb8926a7fe6.jpeg",
    "https://cdn.faire.com/fastly/7ab8954982065f4287e72e08363f31742a24f10205750518ea6914e5038f8885.jpeg",
    "https://cdn.faire.com/fastly/255e781d7da1891d2721cf5a02cec13610969fafa2655806edf917cb3a719020.jpeg",
    "https://cdn.faire.com/fastly/2479669d9b5ea5ff697a50989f53b153fe1c455f37f8a76a8abb93fab621f332.jpeg",
    "https://cdn.faire.com/fastly/a6d20438cdce215a2f433d53440e30469241a0d11fbcef1148a9441ce0bccdc9.jpeg",
    "https://cdn.faire.com/fastly/46d6a48b81c184ea24ba6c17a3d72cd04301f22fcc9f00f8a46f4c6785c98ee5.jpeg",
  ],
  priceDollars: 118.5,
  description:
    "- Crew neckline\n- Short-sleeve \n- 95%Cotton 5% Spandex maxi dress\n- All-over striped print\n- Regular fit\n- Side slits \n- Shift silhouette\n- Slips on overhead\n- Unlined\n- Comfortable, relaxed fit\n- From daily wear and lounge to going out and night out, this striped dress is perfect for \n  any occasion.  You can wear it to graduation, party, date, travel, vacation, beach, and \n  homecoming.\n- Best seller\n* Model is 5'8, 32-27-34, wearing SMALL",
  tags: [],
  msrpDollars: 237,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:47.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
